import { useState, type FormEvent } from 'react';
import { signInWithEmail, signInWithGoogle, authErrorMessage } from '@/lib/auth';

interface SignInFormProps {
  onSuccess: () => void;
  onSwitchMode: (mode: 'signup' | 'reset') => void;
}

export default function SignInForm({ onSuccess, onSwitchMode }: SignInFormProps) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signInWithEmail(email.trim(), password);
      onSuccess();
    } catch (err) {
      setError(authErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  async function handleGoogle() {
    setError(null);
    setBusy(true);
    try {
      await signInWithGoogle();
      onSuccess();
    } catch (err) {
      setError(authErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="auth-form">
      <label className="auth-field">
        <span className="auth-label">Email</span>
        <input
          type="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={busy}
        />
      </label>
      <label className="auth-field">
        <span className="auth-label">Password</span>
        <input
          type="password"
          autoComplete="current-password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={busy}
        />
      </label>

      {error && <div className="auth-error">{error}</div>}

      <button type="submit" className="btn block" disabled={busy}>
        {busy ? 'Signing in…' : 'Sign In →'}
      </button>
      <button type="button" className="btn dark block" onClick={handleGoogle} disabled={busy}>
        Continue with Google
      </button>

      <div className="auth-links">
        <button type="button" className="auth-link" onClick={() => onSwitchMode('reset')}>
          Forgot password?
        </button>
        <button type="button" className="auth-link" onClick={() => onSwitchMode('signup')}>
          Create account →
        </button>
      </div>
    </form>
  );
}
